import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { hot } from 'react-hot-loader';
import { Security } from '@okta/okta-react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import App from './containers/App';
import ScrollToTop from './containers/ScrollToTop';
import PaymentCallback from './components/PaymentCallback';
import store from './store';
import './theme';

const appDom = document.getElementById('app');

console.log(`Starting React App @ ${process.env.VERSION}`); // eslint-disable-line no-console

const DummyDsmPayment = () => <div>Loading...</div>;

const RootWithSecurity = () => (
  <Security
    issuer={process.env.OKTA_ISSUER}
    client_id={process.env.OKTA_CLIENT_ID}
    redirect_uri={`${window.location.origin}/implicit/callback`}
    scope={['openid', 'email', 'profile', 'groups']}
  >
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </Security>
);

const Root = () => (
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route path="/dsmCallback" component={PaymentCallback} />
        <Route path="/dsmPayment" component={DummyDsmPayment} />
        <Route component={RootWithSecurity} />
      </Switch>
    </BrowserRouter>
  </Provider>
);
export default hot(module)(Root);

const renderUI = () => {
  // Render the main app react component into the app div.
  ReactDOM.render(<Root />, appDom);
};

renderUI();



// WEBPACK FOOTER //
// ./src/app/app.js